import { render, staticRenderFns } from "./IconChat.vue?vue&type=template&id=69bb2fcc"
import script from "./IconChat.vue?vue&type=script&lang=js"
export * from "./IconChat.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports